import { DATES } from '../../services/constants/dates-constants';

import { DATES_ID } from '../../services/constants/dates-constants';
import { TTableStructureFilter } from './types';

export const DATE_FILTER: TTableStructureFilter = [
	[DATES_ID.TODAY, DATES.TODAY],
	[DATES_ID.YESTERDAY, DATES.YESTERDAY],
	[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
	[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
	[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
	[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
	[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
	[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
	[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
	[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
	[DATES_ID.CUSTOM_RANGE, DATES.CUSTOM_RANGE],
];

export const DATE_RANGE_FILTER: TTableStructureFilter = [
	[DATES_ID.LAST_MONTH, 'Previous month'],
	[DATES_ID.LAST_QUARTER, 'Previous quarter'],
	[DATES_ID.THIS_QUARTER, 'Current quarter'],
	[DATES_ID.THIS_YEAR, 'Current year'],
	[DATES_ID.CUSTOM_RANGE, DATES.CUSTOM_RANGE],
];
